import { useEffect } from "react";

import { Opco } from "types/Opco";

import getOpco from "utils/getOpco";

import { getDomainPartnerFromHost } from "utils/getDomainPartnerFromHost";

const ENABLED_OPCO_DOMAINS = {
  lowi: ["lw"],
  vodafone: ["es", "it", "gb", "de", "eg", "pt", "za", "ro", "cz", "tr", "gr"],
};

const useDomainGatekeeper = () => {
  const domain = getDomainPartnerFromHost();
  const opco: Opco = getOpco();
  useEffect(() => {
    if (domain && ENABLED_OPCO_DOMAINS[domain].indexOf(opco) < 0) {
      window.location.replace("https://offers.vodafone.com/page-not-found");
    }
  }, [domain, opco]);
};

export default useDomainGatekeeper;
